import {
  Box,
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import React from "react";
import { useNavigate } from "react-router-dom";

import { FiAlertCircle } from "react-icons/fi";
import { goToLogin } from "../../../routes/coordinator";
import { GRAY, GRAY_LIGHT, REDMONEDD, WHITE } from "../../../constants/colors";

const ModalLogout = ({ isOpen, setIsOpen }: any) => {
  const finalRef = React.useRef(null);
  const navigate = useNavigate();

  const onClose = () => {
    setIsOpen(false);
  };

  const logout = () => {
    window.localStorage.removeItem("token");
    window.localStorage.removeItem("user");
    goToLogin(navigate);
    window.location.reload();
  };

  return (
    <>
      <Modal
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={onClose}
        size={"xl"}
      >
        <ModalOverlay backdropFilter="blur(10px)" />
        <ModalContent>          
          <Box
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
            w={"100%"}
            h={"110px"}
          >
            {<FiAlertCircle color={REDMONEDD} size={70} />}
          </Box>
          <ModalBody>
            <Box
              h={"70px"}
              justifyContent={"center"}
              textAlign={"center"}
              alignContent={"center"}
            >
              <Text fontSize="2xl">Deseja sair do sistema?</Text>
            </Box>
          </ModalBody>

          <ModalFooter justifyContent={"space-evenly"}>
            <Button background={GRAY_LIGHT} mr={3} onClick={onClose}>
              Cancelar
            </Button>
            <Button background={REDMONEDD} color={WHITE} onClick={logout}>
              Confirmar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default ModalLogout;
